import axios from 'axios';
import useSWR, { useSWRConfig } from 'swr';

import { getApiUrl } from '@/helpers/api';

export const useAvailabilitySelf = (date) => {
  const urlStr = date
    ? `${getApiUrl()}/availability/self?date=${date}`
    : `${getApiUrl()}/availability/self`;

  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useAvailabilities = (coachId, activityId, date) => {
  const urlStr =
    coachId && activityId
      ? `${getApiUrl()}/availability?coachId=${coachId}&activityId=${activityId}${
          date ? `&date=${date}` : ''
        }`
      : null;

  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 30 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

// Add this hook to invalidate all availability data
export const useInvalidateAvailability = () => {
  const { mutate } = useSWRConfig();

  const invalidateAll = () => {
    // This will invalidate any key that matches the regex pattern
    return mutate(
      (key) =>
        typeof key === 'string' &&
        key.startsWith(`${getApiUrl()}/availability`),
      undefined,
      { revalidate: true }
    );
  };

  return invalidateAll;
};

export const usePostAvailability = () => {
  const postAvailability = async (payload) => {
    try {
      const url = `${getApiUrl()}/availability`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postAvailability;
};

export const usePutAvailability = () => {
  const putAvailability = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/availability/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return putAvailability;
};

export const useDeleteAvailability = () => {
  const deleteAvailability = async (id) => {
    try {
      const url = `${getApiUrl()}/availability/${id}`;
      const response = await axios.delete(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return deleteAvailability;
};
